import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackButton.css";

const BackButton = () => {
    const navigate = useNavigate();

    return (
        <button className="back-button" onClick={() => navigate("/home")}>
            <span className="back-button-arrow">&#8592;</span>
            <span className="back-button-label">Home</span>
        </button>
    );
};

export default BackButton;
